module.exports = __webpack_public_path__ + "img/paperclip.2140d1cd.svg";